<template>
  <div class="app-container">
    <div class="card settings">
      <div class="section-title">设置</div>
      <div class="setting-item">
        <span>账号</span>
        <span class="phone num">{{ maskedPhone }}</span>
      </div>
      <div class="setting-item">
        <span>显示最近</span>
        <a-select
          v-model:value="selectedDays"
          style="width: 80px; margin: 0 8px"
        >
          <a-select-option v-for="day in daysOptions" :key="day" :value="day">
            {{ day }}天
          </a-select-option>
        </a-select>
        <span>的投注记录</span>
      </div>

      <div class="setting-item" v-if="userId == 1">
        <a-button @click="onClickEnableClear">启用清理功能</a-button>
      </div>

      <a-button id="logout" type="primary" @click="logout">退出登录</a-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  components: {
  },
  data() {
    return {
      daysOptions: [3, 7, 10, 15, 30],
      selectedDays: this.$store.state.settings.history_days
    }
  },
  computed: {
    ...mapState('settings', ['history_days']),
    userId() {
      return localStorage.getItem('userId')
    },
    maskedPhone() {
      const phone = localStorage.getItem('phone') || ''
      // 隐藏中间 4 位：13812345678 -> 138****5678
      return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') || '未知'
    }
  },
  watch: {
    selectedDays(newVal) {
      this.updateHistoryDays(newVal)
    }
  },
  methods: {
    ...mapActions('settings', ['updateHistoryDays']),
    ...mapActions('verify', ['enableClear']),
    onClickEnableClear() {
      this.enableClear(true);
    },
    logout() {
      // 清除登录状态
      localStorage.removeItem('isLoggedIn');
      this.$router.push('/');
    }
  }
}
</script>

<style scoped>
.settings {
  max-width: 480px;
}
.setting-item {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 12px 0;
  border-bottom: 1px solid var(--line);
  color: var(--ink);
}
.phone {
  margin-left: 10px;
  font-weight: 600;
  letter-spacing: .04em;
  color: var(--pitch-900);
}
#logout {
  margin-top: 20px;
}
</style>
